<template>
    <v-main>
      <head>
        <title>
          Garden Finder - Foraje
        </title>
        <meta name="description" content="Find gardeners, farmers, and local food producers near you">
      </head>
      <h1 style="text-align: center">Garden Finder</h1>
      <v-container
        fluid
      >
        <v-row
        >
          <v-col cols="12" md="4">
            <v-card class="fill-height">
              <form @submit.prevent="SubmitAddressForGeocoding">
            <v-toolbar
              dense
            >
              <v-text-field
                label="Search near..."
                hide-details
                single-line
                append-icon="mdi-magnify"
                v-model="address"
                :loading="address_response_loading"
                :disabled="address_response_loading"
                @click:append="SubmitAddressForGeocoding"
                required
              />
<!--TODO product preview, show like 3 products from a selected shop-->
              <v-btn icon @click="RequestUserLocation">
                <v-icon>mdi-crosshairs-gps</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
              </form>
              <v-card-title>
                <h2 v-if="list_or_card==='card'">Selected Shop</h2>
                <h2 v-if="list_or_card==='list'">Nearby Farmstands</h2>
                <v-spacer/>
                <v-btn-toggle
                  v-model="list_or_card"
                  mandatory
                >
                  <v-btn value="list" :disabled="!growing_locations_loaded">
                    <v-icon>mdi-format-list-bulleted</v-icon>
                  </v-btn>
                  <v-btn value="card" :disabled="!growing_locations_loaded">
                    <v-icon>mdi-storefront</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-card-title>
              <v-card-text v-if="list_or_card==='list'">
                <div v-if="address_response_loading">
                  <v-container>
                    <v-row >
                      <v-col cols="12" class="text-center">
                        <v-progress-circular
                          :size="100"
                          :width="7"
                          color="primary"
                          indeterminate
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <ol v-else>
                  <li v-for="location in visibleGrowingLocations" :key="location.id"
                      @click="LocationCardSelectedFromList(location)">
                    <h3 class="primary--text" style="cursor: pointer; text-decoration: underline">{{location.name}}</h3>
                    <span v-if="location.address">{{location.address}}</span>
                    <span v-else>Address Unknown</span>
                    <br>
                    <span v-if="location.distance">
                      <em>{{converteddistancevalue(location.distance)}} miles away</em>
                    </span>
                    <span v-else>Unknown Distance Away</span>
                  </li>
                  <v-pagination v-model="page" :length="Math.ceil(growing_locations.length/perPage)"></v-pagination>
                </ol>
              </v-card-text>
              <v-card-text v-if="list_or_card==='card'">
                <v-card>
                  <v-card-title>
                    <router-link :to="'/shops/' + selected_growing_location.slug" >
                      {{selected_growing_location.name}}
                    </router-link>
                  </v-card-title>
                  <v-card-text>
                    {{selected_growing_location.address}}
                  </v-card-text>
                  <v-card-text>
                    {{selected_growing_location.description.substring(0,255)}}
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="8" class="map"
          >
            <v-card class="fill-height">
            <l-map ref="map" :zoom="zoom" :center="center" :world-copy-jump="true">
              <!--<l-tile-layer
                :url="'https://api.tiles.mapbox.com/v4/mapbox.streets/{z}/{x}/{y}.png?access_token='
                + accessToken" :attribution="attribution"/>-->
              <l-tile-layer :url="'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=' + accessToken"
              />
              <l-marker v-for="location in growing_locations" :key="location.id"
                        :visible="location.visible"
                        :lat-lng="location.position"
                        iconSize=[24,36]
                        iconAnchor=[12,36]
                        @click="VendorCardSelectedFromMap(vendor)"
                        @mouseover="MarkerMouseover($event.target)"
                        @mouseleave="CancelMarkerMouseover"
              >
                <l-popup>
                  <router-link :to="'/gardens/' + location.slug"><span style="text-align: center">{{location.name}}</span></router-link>
                  <p style="font-size: smaller">{{location.address}}</p>
                </l-popup>
              </l-marker>
              <l-marker v-if="userlocation && userlocation.length"
                        :lat-lng="userlocation"
                        iconSize=[24,36]
                        iconAnchor=[12,36]
              >
                <l-popup>
                  <p style="font-size: smaller">This is you!</p>
                </l-popup>
              </l-marker>
            </l-map>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
</template>

<script>
import {
  LMap, LTileLayer, LMarker, LPopup,
} from 'vue2-leaflet';
import L from 'leaflet';

import axios from 'axios';


export default {
  name: 'GrowingLocationFinder',
  data: () => ({
    drawer: null,
    // leaflet stuff
    center: [42.33790250820482, -71.07986328120639],
    marker: [],
    zoom: 3,
    accessToken: process.env.VUE_APP_MAPBOX_API_KEY,
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    map: null,
    mousestillover: false,
    /* TODO @change of map tiles, do another search for growers in that area.
        Or maybe instead, for now just load all growers and put their markers on there? */
    list_or_card: 'start',
    growing_locations: [],
    growing_locations_loaded: false,
    selected_growing_location: [],
    userlocation: [],
    GeoJsonCoords: [],
    address: '',
    address_response_loading: false,
    disablebuttons: true,
    page: 1,
    perPage: 10,
    showfullhours: false,
  }),
  computed: {
    visibleGrowingLocations() {
      return this.growing_locations.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },
    todayIs() {
      const date = new Date();
      return date.toLocaleDateString((window.navigator.language), { weekday: 'long' });
    },
  },
  props: {
    source: String,
  },
  components: {
    LMap, LTileLayer, LMarker, LPopup,
  },

  mounted() {
    // Make leaflet callable
    if (this.center.length) {
      this.$nextTick(() => {
        this.map = this.$refs.map.mapObject; // work as expected
      });
    }
    this.RequestUserLocation();
  },
  methods: {
    GetMapReady() {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 5);
    },
    dontPropagate() {
      // eslint-disable-next-line no-restricted-globals
      event.stopPropagation();
    },
    RequestUserLocation() {
      navigator.geolocation.getCurrentPosition(this.UserLocationSuccess);
    },

    UserLocationSuccess(pos) {
      const crd = pos.coords;
      this.userlocation = [crd.latitude, crd.longitude];
      this.GeoJsonCoords = [crd.longitude, crd.latitude];
      this.center = [crd.latitude, crd.longitude];
      this.marker = [crd.latitude, crd.longitude];
      this.zoom = 12;
      this.list_or_card = 'list';

      return this.SubmitUserCoordinates();
    },
    VendorCardSelectedFromMap(vendor) {
      this.list_or_card = 'card';
      this.selectedvendor = vendor;
    },
    VendorCardSelectedFromList(vendor) {
      this.list_or_card = 'card';
      this.selectedvendor = vendor;
      console.log(vendor);
      // this will probably load more tiles than is strictly necessary, but it looks nice, right?
      // if we restrict the found shops to only be within like 50 miles or something,
      // it shouldn't be too bad.
      if (this.map.getBounds().contains(vendor.position)) {
        this.map.flyTo(vendor.position);
      } else {
        this.$refs.map.setCenter(vendor.position);
      }
    },
    // Record the coordinates received from getCurrentPosition to backend
    SubmitUserCoordinates() {
      const authheader = `Token ${this.$store.getters.token}`;
      this.address_response_loading = true;
      const locationdata = {
        coordinates: {
          type: 'Point',
          coordinates: this.GeoJsonCoords,
        },
        address: '',
      };
      axios.post('forms/maps/submitted_location/growing_location/create/', locationdata, {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          this.growing_locations = [];
          response.data.nearest_growing_locations.forEach((location) => {
            if (location.location_coordinates) {
              this.growing_locations.push({
                id: location.id,
                name: location.name,
                slug: location.slug,
                position: L.GeoJSON.coordsToLatLng(location.location_coordinates.coordinates),
                address: location.address,
                distance: location.distance,
                description: location.description,
              });
            }
          });
        })
        .then(() => {
          this.map.setView(this.center);
          this.GetMapReady();
          this.list_or_card = 'list';
          [this.selectedlocation] = this.growing_locations;
          this.growing_locations_loaded = true;
        })
        .then(() => {
          this.address_response_loading = false;
        })
        .catch(() => {
          this.$parent.$emit('alert-emitted', { alert_icon: 'mdi-alert-outline', alert_color: 'warning', alert_message: 'Something went wrong with getting your coordinates. Try again, or try submitting an address instead.' });
          this.address_response_loading = false;
        });
    },
    // If a user submits an address instead of a location,
    // we need to geocode it, and get the coordinates.
    // We'll send the address to the backend, which will then forward it to the geocoding services.
    SubmitAddressForGeocoding() {
      if (this.address) {
        const authheader = `Token ${this.$store.getters.token}`;
        this.address_response_loading = true;
        const locationdata = {
          address: this.address,
          coordinates: null,
        };
        axios.post('forms/maps/submitted_location/growing_location/create/', locationdata, {
          headers: {
            Authorization: authheader,
          },
        })
          .then((response) => {
            this.growing_locations = [];
            response.data.nearest_growing_location.forEach((location) => {
              if (location.location_coordinates) {
                this.growing_locations.push({
                  id: location.id,
                  name: location.name,
                  position: L.GeoJSON.coordsToLatLng(location.location_coordinates.coordinates),
                  address: location.address,
                  distance: location.distance,
                  cleaned_hours: this.cleanHours(location.hours),
                  description: location.description,
                });
              }
            });
            const coords = L.GeoJSON.coordsToLatLng(response.data.decoded_coordinates.coordinates);
            this.center = [coords.lat, coords.lng];
            this.userlocation = [coords.lat, coords.lng];
            this.zoom = 12;
          })
          .then(() => {
            this.list_or_card = 'list';
            [this.selected_growing_location] = this.growing_locations;
            this.growing_locations_loaded = true;
          })
          .then(() => {
            this.map.setView(this.center);
            this.address_response_loading = false;
          })
          .catch(() => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-alert-outline',
              alert_color: 'warning',
              alert_message: 'Something went wrong with finding this address. Try using the locator function instead.',
              alert_model: true,
            });
            this.address_response_loading = false;
          });
      }
    },
    converteddistancevalue(distance) {
      return (distance / 1609.344).toFixed(2);
    },
    MarkerMouseover(eventtarget) {
      this.mousestillover = true;
      setTimeout(() => { this.FireMarkerPopup(eventtarget); }, 1000);
    },
    CancelMarkerMouseover() {
      this.mousestillover = false;
    },
    FireMarkerPopup(eventtarget) {
      if (this.mousestillover) {
        eventtarget.openPopup();
      }
    },
    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },
    cleanHours(array) {
      const output = array.reduce((o, cur) => {
        let newO = o;
        // Get the index of the key-value pair.
        const occurs = o.reduce((n, item, i) => ((item.weekday === cur.weekday) ? i : n), -1);

        // If the name is found,
        if (occurs >= 0) {
          // append the current value to its list of values.
          newO[occurs].open_time = newO[occurs].open_time.concat(cur.open_time);
          newO[occurs].close_time = newO[occurs].close_time.concat(cur.close_time);

          // Otherwise,
        } else {
          // add the current item to o (but make sure the value is an array).
          const obj = {
            weekday: cur.weekday,
            weekday_display: cur.weekday_display,
            open_time: [cur.open_time],
            close_time: [cur.close_time],
          };
          newO = newO.concat([obj]);
        }

        return newO;
      }, []);

      return output;
    },
  },
};
</script>
<style scoped>
  .map{
    /*min-height: 500px;*/
    height: 80vh;
    margin: 0;
  }
</style>
